import { FC, useState, ChangeEvent } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { RecoveryRequestFormProps } from './types';
import { getPath } from './paths';
import axios from 'server';
import { Grid, TextField, Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { handleCompanyUrl } from 'utils/organizationUtils';
// import { useParams } from 'react-router-dom';
// import { OrganizationParamUrl } from 'containers/SignInEndUser/types';

export const RecoveryRequestForm: FC<RecoveryRequestFormProps> = ({ type, title }) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    notificationStore: { openNotification },
    appPreloaderStore: { disablePreloader },
  } = useStore();

  const [email, setEmail] = useState<string>('');
  const forgotPasswordReq = useMutation((email: string) => axios.post(getPath(type), { email }), {
    mutationKey: 'forgotPasswordReq',
    onSuccess: () => {
      openNotification('success', `Sent successfully. Check your inbox.`);
      disablePreloader();
      history.push(handleCompanyUrl('/login'));
    },
    onError: () => {
      openNotification('error', `User not found`);
    },
  });

  useAppPreloader(forgotPasswordReq.isLoading);

  return (
    <Grid container className={classes.main} justify='center' spacing={2}>
      <Paper className={classes.paper} elevation={3}>
        <h1 className={classes.title}>{title}</h1>
        <Grid container justify='center'>
          <TextField
            color='primary'
            className={classes.formControl}
            id='email'
            required
            fullWidth
            variant='outlined'
            label='Email'
            autoFocus
            onChange={(event: ChangeEvent<{ value: unknown }>) => setEmail(event.target.value as string)}
          />
        </Grid>
        <Grid className={classes.buttonBox} container justify='space-between'>
          <Button
            className={classes.link}
            onClick={() => {
              type !== 'admin-forgot-password' ? history.goBack() : history.goBack();
            }}
          >
            Back
          </Button>
          <Button
            className={classes.button}
            variant='contained'
            color='primary'
            onClick={() => forgotPasswordReq.mutate(email)}
          >
            SEND INSTRUCTION
          </Button>
        </Grid>
      </Paper>
    </Grid>
  );
};
